import { render, staticRenderFns } from "./SettingsPrint.vue?vue&type=template&id=5110e98d"
import script from "./SettingsPrint.vue?vue&type=script&lang=js"
export * from "./SettingsPrint.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports